import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetOcrTradesRequestModel, GetOcrTradesResponseModel } from "@/features/accounts/ocr/services/get-trades-model";

export class GetOcrTradesApi {
  /**
   * OCR明細取得API
   */
  public getOcrTrades = async (
    param: GetOcrTradesRequestModel
  ): Promise<GetOcrTradesResponseModel[]> => {
    const path = `/api/ocraccounts/trades`;
    const res = await ApiClient.instance.get<GetOcrTradesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
